import UpdateAuthLicense from "src/components/UpdateAuthLicense/UpdateAuthLicense";

export type IUpdateAuthLicenseCallback = () => void;

export default {
    updateAuthLicenseComponent: null,

    dispose() {
        if (this.updateAuthLicenseComponent) {
            this.updateAuthLicenseComponent.dispose();
        }
        this.updateAuthLicenseComponent = null;
    },

    show(callback: IUpdateAuthLicenseCallback) {
        if (!this.updateAuthLicenseComponent) {
            this.updateAuthLicenseComponent = new UpdateAuthLicense({
                source: '<x-update-auth-license></x-update-auth-license>'
            });
            this.updateAuthLicenseComponent.attach(document.body);
        }
        this.updateAuthLicenseComponent.show(callback)
    }
};